// import lib
import { lazy } from "react";

const routes = [
  {
    exact: true,
    path: "/",
    element: lazy(() => import("../pages/SignIn")),
  },
];

export default routes;
